module.exports = __webpack_public_path__ + "static/img/registration.c746230.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/registration.jpg
// module id = CW5H
// module chunks = 1